/* ========== 対象処理 ========== */
// ポイント履歴ページ

document.addEventListener("DOMContentLoaded", function () {
  const pointArea = document.querySelector('.account-pointHistory');
  const now = new Date();
  const year = now.getFullYear();

  // ポイント履歴ページ
  if (pointArea) {
    setYear(year);
    setPointHistory(year, 1);

    // 表示年選択
    document.addEventListener("change", async (e) => {
      if (!e.target || !e.target.value) {
        return false;
      }

      setPointHistory(e.target.value, 0);
    });
  }
});

/**
 * ポイント履歴ページ表示
 *
 * @param {string} year
 * @param {number} firstFlg 0: 2回目以降, 1: 初回
 */
const setPointHistory = async (year, firstFlg) => {
  const points = await getPointHistory(year);

  if (!points || !points.result) {
    return;
  }

  if (firstFlg) {
    setPointOverview(points);
  }
  setPointHistoryList(points.pointHistories);
};

/**
 * ポイント履歴ページ表示
 *
 * @param {string} year
 */
const getPointHistory = async (year) => {
  const url = new URL(`${APP_PROXY_URL}/api/customer/payments`);
  url.searchParams.set('history_type', 2);
  url.searchParams.set('display_method', 1);
  url.searchParams.set('year', year);
  url.searchParams.set('number_of_data_unit', 100);
  url.searchParams.set('page_number', 1);

  const res = await fetchGetMethod(url.href);

  return res && res.result
    ? res
    : null;
};

/**
 * ポイント履歴欄作成
 *
 * @param {Array} histories
 */
const setPointHistoryList = (histories) => {
  let pointList = document.querySelector('.account-pointHistory ._list');

  while (pointList.firstChild) {
    pointList.removeChild(pointList.firstChild);
  }

  if (histories.length == 0) {
    return;
  }

  histories.forEach(history => {
    // pointAmount が '０'の場合スキップする
    if (Number(history.pointAmount) == 0) {
      return;
    }

    let pointItem = document.createElement('div');
    let pointData = document.createElement('p');
    let pointName = document.createElement('p');
    let div = document.createElement('div');
    let pointTag = document.createElement('p');
    let p = document.createElement('p');
    let spanPoint = document.createElement('span');
    let span = document.createElement('span');

    pointItem.className = setPointClass(history.pointCategory);
    pointData.innerText = formatDate(history.pointDate);
    pointData.className = '_date';
    pointName.className = '_name';
    pointName.innerHTML = setPointTitle(history);
    pointTag.innerText = setPointTag(history.pointCategory);
    spanPoint.innerText = setPoint(history);
    span.innerText = 'ポイント';

    pointItem.appendChild(pointData);
    pointItem.appendChild(pointName);
    div.appendChild(pointTag);
    p.appendChild(spanPoint);
    p.appendChild(span);
    div.appendChild(p);
    pointItem.appendChild(div);
    pointList.appendChild(pointItem);
  });
};

/**
 * 付与class設定
 *
 * @param {string} category
 * @returns
 */
const setPointClass = (category) => {
  if (PLUS_CATEGORY.indexOf(category) != -1) {
    return '_plus';
  }

  if (MINUS_CATEGORY.indexOf(category) != -1) {
    return '_minus';
  }

  return '';
};

/**
 * タグ名設定
 *
 * @param {string} category
 * @returns
 */
const setPointTag = (category) => {
  let num = Number(category);
  return POINT_CATEGORY[num] ?? 'その他';
};

/**
 * ポイントタイトル設定
 *
 * @param {*} history
 * @returns
 */
const setPointTitle = (history) => {
  // 購入・利用
  if (history.storeName) {
    return history.storeName;
  }

  // CRM管理画面でポイント操作した場合
  if (OPERATION_CATEGORY.indexOf(history.pointCategory) != -1) {
    return `ISSEY MIYAKE INC.<br>${history.pointRemarks}`;
  }

  return history.pointRemarks;
};

/**
 * ポイント設定
 *
 * @param {*} history
 * @returns
 */
const setPoint = (history) => {
  const amout = Number(history.pointAmount).toLocaleString();
  const mark = MINUS_CATEGORY.indexOf(history.pointCategory) != -1 ? '-' : '';

  return mark + amout;
};
